module.exports = {
    title: 'Título',
    typeHere: 'Digite aqui...',
    create: 'Criar',
    description: "Descrição",
    errors: {
		default: "Algo deu errado... tente mais tarde.",
	},
}